<div class="card">
    <div class="card-header">
        <h2>{{ 'shared.heading.program-details' | translate }}</h2>
    </div>
    <div class="card-body">
        <div class="heading">
            <h3>{{ program.name }}</h3>
        </div>

        <p [innerHTML]="program.description || '...'"></p>

        <div *ngIf="program.legal_terms">
            <div class="action-link">
                <a (click)="iTermsOpen = !iTermsOpen">{{ (iTermsOpen ? 'shared.button.terms-hide' : 'shared.button.terms-show') | translate }}</a>
                <span>{{ (iTermsOpen ? '▲' : '▼' )}}</span>
            </div>

            <div [hidden]="!iTermsOpen" class="terms" [innerHTML]="program.legal_terms | newlines"></div>
        </div>
    </div>
</div>
